document.addEventListener('turbolinks:load', function () {
  var items = document.querySelectorAll('[data-accordion]');
  if (!items.length) return;

  items.forEach(function (details) {
    var summary = details.querySelector('summary');
    var body    = details.querySelector('[data-accordion-body]');
    if (!summary || !body) return;

    var busy = false;

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (busy) return;
      busy = true;
      details.open ? collapse() : expand();
    });

    function expand() {
      details.setAttribute('open', '');

      body.style.overflow   = 'hidden';
      body.style.height     = '0px';
      body.style.opacity    = '0';
      body.style.transition = 'none';
      body.getBoundingClientRect(); // flush so browser registers zero state

      body.style.transition = 'height 480ms cubic-bezier(0.16, 1, 0.3, 1), opacity 420ms cubic-bezier(0.16, 1, 0.3, 1)';
      body.style.height     = body.scrollHeight + 'px';
      body.style.opacity    = '1';

      body.addEventListener('transitionend', function done(e) {
        if (e.propertyName !== 'height') return;
        body.removeEventListener('transitionend', done);
        body.style.removeProperty('height');
        body.style.removeProperty('opacity');
        body.style.removeProperty('overflow');
        body.style.removeProperty('transition');
        busy = false;
      });
    }

    function collapse() {
      // Pin to exact pixel height — can't transition from 'auto'
      body.style.height     = body.scrollHeight + 'px';
      body.style.overflow   = 'hidden';
      body.style.transition = 'none';
      body.getBoundingClientRect(); // flush

      // Height only — no opacity. Content clips cleanly without a mid-animation hard stop.
      body.style.transition = 'height 400ms cubic-bezier(0.4, 0, 0.2, 1)';
      body.style.height     = '0px';

      body.addEventListener('transitionend', function done(e) {
        if (e.propertyName !== 'height') return;
        body.removeEventListener('transitionend', done);
        details.removeAttribute('open');
        body.style.removeProperty('height');
        body.style.removeProperty('overflow');
        body.style.removeProperty('transition');
        busy = false;
      });
    }
  });
});
